module.exports = __webpack_public_path__ + "static/media/meeting.d5359b26.svg";